module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/core/home/home.component.css
// module id = ./src/app/core/home/home.component.css
// module chunks = main